import { render, staticRenderFns } from "./StudyMappingIndividualReviewByCitations.vue?vue&type=template&id=41f21c7d"
import script from "./StudyMappingIndividualReviewByCitations.vue?vue&type=script&lang=js"
export * from "./StudyMappingIndividualReviewByCitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports